import React from "react";
import { Link } from "react-router-dom";
import moment from "moment-timezone";
import Tooltip from "@mui/material/Tooltip";

import shortenName from "../../helpers/shorten-name";

const tripTypeConfig = {
  commissionOnly: { label: "Commission Only" },
  allInternational: { label: "All International" },
  international: { label: "International" },
  internationalWarning: { label: "International", color: "orange", fontWeight: "bold" },
  domestic: { label: "Domestic" },
  domesticWarning: { label: "Domestic", color: "orange", fontWeight: "bold" },
};

const FET_TRIP_TYPE_LABELS = {
  domestic: "US Domestic",
  "225zone": "225 mi. Zone",
  usInternational: "US International",
  allInternational: "All International",
  custom: "Custom",
  operatorCollected: "Operator Collected",
  passThrough: "Pass-through",
  commissionOnly: "Commission Only",
  multiple: "Multiple",
};

const columns = [
  {
    name: "Trip # Match",
    selector: "tripMatch",
    sortable: true,
    width: "100px",
  },
  {
    name: "Trip #",
    selector: "tripTag",
    sortable: true,
    cell: (row) => {
      return (
        <Link className="ellipsis-cell" to={`/trips/${row.tripId}`} target="_blank" rel="noopener noreferrer">
          <Tooltip title={row.tripTag} arrow>
            {row.tripTag}
          </Tooltip>
        </Link>
      );
    },
    width: "110px",
  },
  {
    name: "Owner",
    selector: "ownerName",
    sortable: true,
    width: "150px",
    cell: (row) => {
      return shortenName(row.ownerName);
    },
  },
  {
    name: "Create Date",
    selector: "signedAt",
    sortable: true,
    width: "100px",
    cell: (row) => {
      return row.signedAt ? moment(row.signedAt).format("M/D/YY") : "";
    },
  },
  {
    name: "Create Period",
    selector: "signedPeriod",
    sortable: true,
    width: "100px",
    cell: (row) => {
      return row.signedPeriod ? moment(row.signedPeriod).format("M/D/YY") : "";
    },
  },
  {
    name: "Start Date",
    selector: "startDate",
    sortable: true,
    width: "100px",
    cell: (row) => {
      return row.startDate ? moment(row.startDate).format("M/D/YY") : "";
    },
  },
  {
    name: "End Date",
    selector: "endDate",
    sortable: true,
    width: "100px",
    cell: (row) => {
      return row.endDate ? moment(row.endDate).format("M/D/YY") : "";
    },
  },
  {
    name: "Client Name",
    selector: "clientName",
    sortable: true,
    width: "200px",
    cell: (row) => {
      return (
        <Tooltip
          classes={{
            tooltip: "multiline-tooltip",
          }}
          title={row.clientName}
        >
          <div className="two-line-content">
            {row.clientName}
          </div>
        </Tooltip>
      );
    },
  },
  {
    name: "Trip Legs",
    selector: "tripLegs",
    sortable: true,
    width: "200px",
    wrap: true,
  },
  {
    name: "Client Type",
    selector: "clientType",
    sortable: true,
    width: "90px",
    cell: (row) => {
      return row.clientType || "";
    },
  },
  {
    name: "Trip Type",
    selector: "tripType",
    sortable: true,
    width: "150px",
    cell: (row) => {
      if (row.isFetTripType) {
        return <span>{FET_TRIP_TYPE_LABELS[row.tripType] || row.tripType}</span>;
      }

      const config = tripTypeConfig[row.tripType];

      if (config) {
        return (
          <span
            style={{
              color: config.color,
              fontWeight: config.fontWeight,
            }}
          >
          {config.label}
        </span>
        );
      }

      return (
        <span
          style={{
            color: "red",
            fontWeight: "bold",
          }}
        >
          Error
        </span>
      );
    },
  },
  {
    name: "Lead Source",
    selector: "leadSource",
    sortable: true,
    width: "100px",
    cell: (row) => {
      return row.leadSource || "";
    },
  },
  {
    name: "First Contact",
    selector: "firstContact",
    sortable: true,
    width: "100px",
    cell: (row) => {
      return row.firstContact ? moment(row.firstContact).format("M/D/YY") : "";
    },
  },
  {
    name: "Route Type",
    selector: "routeType",
    sortable: true,
    width: "70px",
  },
  {
    name: "Operator 1",
    selector: "operator",
    sortable: true,
    width: "130px",
    cell: (row) => {
      return (
        <Tooltip
          classes={{
            tooltip: "multiline-tooltip",
          }}
          title={row.operator || ""}
        >
          <div className="two-line-content">
            {row.operator || ""}
          </div>
        </Tooltip>
      );
    },
  },
  {
    name: "Aircraft 1",
    selector: "aircraft",
    sortable: true,
    width: "130px",
    cell: (row) => {
      return (
        <Tooltip
          classes={{
            tooltip: "multiline-tooltip",
          }}
          title={row.aircraft || ""}
        >
          <div className="two-line-content">
            {row.aircraft || ""}
          </div>
        </Tooltip>
      );
    },
  },
];

export { tripTypeConfig, FET_TRIP_TYPE_LABELS, columns };
